import { Component, Input, SimpleChange, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from '../../Model/api-model';
import { RestApiService } from 'src/app/Services/rest-api-service';
import { SubscriptionList, Subscription, ProductPlan, Plan, PlanApis } from 'src/app/Model/product-model';
import {MessageModule} from 'primeng/message';
import {Message,MessageService} from 'primeng/api';
@Component({
  selector: 'app-viewapp',
  templateUrl: './app.viewapp.html'
})
export class ViewAppComponent implements OnChanges {
   apis:Api[];
   cols: any[];
   msgs: Message[] = [];
   showDivforUnsub:boolean=true;
   showSpiner:boolean=false;
   @Input() appName:string;
   @Input() appCallBackUrl:string; 
   @Input() appID:string;
   @Input() pathInfo:string;
   subscriptionListForAnApp:SubscriptionList;
   subscriptionForAnApp:Subscription[];
   subscriptionID:string;
   selectedSub:Subscription;
   subCols:any[];
   plans:ProductPlan;
   apisPlan:Plan[];
   apisView:PlanApis[];
   apisPlanCols:any[];
   apisViewEnable=false;
   showGrid=false;
   showNoSubData=false;
   subsriptionerrorToastmessage:string;
   unsubsribeconfirmationPopup:boolean;
   mainDivVisible=true;
   constructor(private router: Router,private restApi: RestApiService,private messageService:MessageService) {}

    ngOnInit() {
      this.apisPlanCols = [
        { field: 'path', header: 'APIs' }
     
    ]; 

      this.subCols = [
        { field: 'productName', header: 'Product Name' },
        { field: 'productVersion', header: 'Product Version' },
        { field: 'plan', header: 'Plan' },
        { field: 'nonProdStatus', header: 'nonProdStatus' },
        { field: 'cssname', header: 'Plan' }];
        
       //   this.cols = [
       //   { field: 'name', header: 'API Names' }];
        
      //    this.apis=[{name:'FHIR Api One',version:'1',status:'Approved',cssname:'qualified',appname:'Sample App One',ischecked:false},
      //    {name:'FHIR Api Two',version:'1',status:'Approved',cssname:'qualified',appname:'Sample App One',ischecked:false},
       //   {name:'FHIR Api Three',version:'1',status:'Pending',cssname:'proposal',appname:'Sample App One',ischecked:false},
       //   {name:'FHIR Api Four',version:'1',status:'Rejected',cssname:'unqualified',appname:'Sample App One',ischecked:false}];
      
          }
 

  mySubscriptionForAnApp(){
     // console.log("here we are")
     this.apisViewEnable=false
     this.showNoSubData=false;
     return this.restApi.mySubscriptionForAnApp(this.appID).subscribe((data: {}) => {
        // console.log(data);   
        this.showGrid=false;
        this.subscriptionListForAnApp=data as SubscriptionList;
        this.subscriptionForAnApp=this.subscriptionListForAnApp.subsApiVO;
       // console.log(this.subscriptionForAnApp); 
       for(const sub of this.subscriptionForAnApp){
          this.showGrid=true;
        // console.log("status "+sub.subscriptionApproved)
          if(sub.subscriptionApproved==true){
            sub.cssname="qualified";
            sub.nonProdStatus="Approved";
          }else{
            sub.cssname="proposal";
            sub.nonProdStatus="Pending";
          } //end of if else
       
        }//end of for

       if(this.showGrid){}else{this.showNoSubData=true;}

       if(this.subscriptionListForAnApp.status==="Failure"){
        const obje_Json=JSON.parse(this.subscriptionListForAnApp.errorMessage);
        const s=Object.values(obje_Json.errors[0]);
        this.subsriptionerrorToastmessage = s.toString();
        this.msgs.push({severity:'error',detail:this.subsriptionerrorToastmessage});   
       }
     
      },(error)=>{

      })
    }
    unsubscriptionConfirmation(sub:Subscription){
      this.unsubsribeconfirmationPopup=true;
      this.subscriptionID=sub.subscriptionID;
    }
    unsubscriptioncancelConfirmation(){
      this.unsubsribeconfirmationPopup=false;
    }
    
   
    unSubscriptionForAnApp(){
      //console.log("here we are")
      this.unsubsribeconfirmationPopup=false;
      this.showSpiner=true;
      this.showDivforUnsub=false;
      this.apisViewEnable=false;
     const subscriptionID=this.subscriptionID;
      //console.log("sub id "+subscriptionID);
      return this.restApi.unSubscriptionForAnApp(this.appID,subscriptionID).subscribe((data: {}) => {
      //  console.log(data);   
        this.showSpiner=false;
        const temp=data as SubscriptionList;
        //console.log("status "+temp.status)

        if(temp.status==="Success"){
          this.msgs.pop();
          this.msgs.push({severity:'info',detail:'You have successfully unsubscribed this plan from this App '+this.appName +""});   
        }else{
          const obje_Json=JSON.parse(temp.errorMessage);
          const s=Object.values(obje_Json.errors[0]);
          this.subsriptionerrorToastmessage = s.toString();
         // console.log(this.subsriptionerrorToastmessage);
          this.msgs.pop();
          this.msgs.push({severity:'error',detail: this.subsriptionerrorToastmessage});   
        }

        
    
    
     },(error)=>{
      this.showSpiner=false;
     })


    
    }
  
    
    viewApisForSubscription(sub:Subscription){
     const productId=sub.productID;
     const plan=sub.plan;
    


     return this.restApi.getProductInfo(productId).subscribe((data: {}) => {
      //this.appList = data;
      this.plans=data as ProductPlan;
      this.apisPlan=this.plans.plans;
     // console.log(this.plans); 
      for(const pln of  this.apisPlan){
         if(pln.name===plan){
           this.apisView=pln.apis;
           this.apisViewEnable=true;
         }
      }

      if(this.plans.status==="Failure"){
        this.msgs.push({severity:'error',detail:'Failed to process you request, ' + this.plans.errorMessage});   
       }

    
    },(error)=>{
      
      // console.log(error);
    })
    
    }

    
   viewStartUp(appID,appName,callback,pathInfo){
  
    this.appID=appID;
    this.appName=appName;
    this.pathInfo=localStorage.getItem("path");
    this.appCallBackUrl=callback;
    this.mainDivVisible=false;
    this.showDivforUnsub=true;
    this.showSpiner=false;
   this.mySubscriptionForAnApp();
   this.msgs=[];

   }


    
    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        //this.childFunction();
        //console.log("selected app "+this.appID);
      //  this.showDivforUnsub=true;
      //  this.showSpiner=false;
      // this.mySubscriptionForAnApp(); 
      }

      ngAfterViewChecked(){
        document.querySelectorAll('table')
        .forEach((input) => {
        //  console.log(input.getAttribute("role"));
           if(input.getAttribute("role")=="grid"){
            input.removeAttribute("role");
           }
         
        });
  
      }
  


    }


